// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"email-settings__visuallyhidden--nhIBv","focusable":"email-settings__focusable--h814Y","container":"email-settings__container--Cf9Zv"};